<template>
  <Notification
    :description="
      $t('rc_notifications_new_provider', {
        ConnectivityProvider: partners[0]?.originalName.value,
        NewConnectivityProvider: partners[1]?.originalName.value,
      })
    "
    v-bind="$attrs"
  >
    <template #ctaContent>
      <div class="tw:mt-3 tw:md:mt-0">
        <BaseLinkButton
          size="medium"
          class="tw:w-full tw:font-bold tw:text-blue-800 tw:text-nowrap"
          @click="upgradePartner"
        >
          <span>{{ $t('notifications_cta_update') }}</span>
        </BaseLinkButton>
      </div>
    </template>
  </Notification>
</template>

<script setup>
import Notification from '@/components/productNotifications/Notification.vue'
import BaseLinkButton from '@/components/base/buttons/BaseLinkButton.vue'

import { usePartnersMutation } from '@/components/rateConnect/queries'
import { selectedAccommodationId } from '@/layouts/queries'

import useToastNotifications from '@/components/notifications/useToastNotifications'
import { usePartnerNames } from '@/components/homePage/queries/conversionFunnel'

const props = defineProps({
  extraParameters: { type: Object, default: () => ({}) },
})
const { changePartner } = usePartnersMutation()
const { displayNotification, showSaveError } = useToastNotifications()
const { partners } = usePartnerNames([
  props.extraParameters?.partnerId,
  props.extraParameters?.alternativePartner?.partnerId,
])

const upgradePartner = () => {
  if (!props.extraParameters.alternativePartner) return
  changePartner(
    {
      itemId: selectedAccommodationId.value,
      partnerId: props.extraParameters.alternativePartner?.partnerId,
    },
    {
      onSuccess: () => {
        displayNotification({
          title: 'setting_updated_success',
          titleTranslationKey: true,
          message: 'rc_connectivity_provider_change_success',
          translationParams: { name: partners.value[1]?.originalName.value },
          isTranslationKey: true,
          isHtml: true,
          type: 'success',
        })
      },
      onError: () => {
        showSaveError()
      },
    }
  )
}
</script>
